<xemex-dialog-shell [title]="'locations.linkDevice.title' | translate">
  <div class="link-device-dialog__body">
    <xemex-table
      [data]="tableData()"
      [columns]="columns"
      [loading]="isLoading()"
      [totalCount]="totalCount()"
      [selectable]="true"
      [selectionKey]="selectionKey"
      [selectedKeys]="selectedKeys()"
      (selectedKeysChange)="onSelectedKeysChange($event)"
      (pageChange)="onPageChange($event)"
    >
      <xemex-table-filter-bar
        [searchPlaceholder]="'devices.filter.placeholderdeviceLDN' | translate"
        (searchChange)="onSearchChange($event)"
      ></xemex-table-filter-bar>
    </xemex-table>

    @if (targets.length) {
      <mat-radio-group
        class="flex flex-col gap-2"
        data-testid="link-target"
        [attr.aria-label]="'locations.linkDevice.target' | translate"
        [value]="choice()"
        (change)="onChoiceChange($event.value)"
      >
        @for (target of targets; track target.installationOid) {
          <mat-radio-button
            class="rounded-lg border border-border-default p-2"
            [value]="target.installationOid"
            data-testid="link-target-installation"
          >
            <span class="flex flex-wrap items-center gap-2 py-1 text-sm font-medium">
              {{ 'locations.linkDevice.addTo' | translate: { name: target.name } }}
              @if (target.commissioningComplete !== null) {
                <xemex-tag
                  [state]="target.commissioningComplete ? 'success' : 'warning'"
                  [label]="
                    (target.commissioningComplete
                      ? 'installations.commissioning.complete'
                      : 'installations.commissioning.incomplete'
                    ) | translate
                  "
                />
              }
            </span>
          </mat-radio-button>
        }
        <mat-radio-button
          class="rounded-lg border border-border-default p-2"
          [value]="NEW_INSTALLATION"
          data-testid="link-target-new"
        >
          <span class="py-1 text-sm font-medium">
            {{ 'locations.linkDevice.newInstallation' | translate }}
          </span>
        </mat-radio-button>
      </mat-radio-group>
    }
  </div>

  <div actions class="link-device-dialog__actions">
    @if (!hasSelection()) {
      <span class="link-device-dialog__hint">
        {{ 'locations.linkDevice.noSelection' | translate }}
      </span>
    } @else if (!hasChoice()) {
      <span class="link-device-dialog__hint">
        {{ 'locations.linkDevice.noChoice' | translate }}
      </span>
    }
    <div class="link-device-dialog__action-group">
      <xemex-text-button type="button" intent="primary" (click)="onCancel()">
        {{ 'general.btnCancel' | translate }}
      </xemex-text-button>
      <xemex-filled-button type="button" [disabled]="!canLink()" (click)="onLink()">
        {{
          (data.installationOid
            ? 'locations.linkDevice.btnLink'
            : 'locations.linkDevice.btnConfirm'
          ) | translate
        }}
      </xemex-filled-button>
    </div>
  </div>
</xemex-dialog-shell>
